<template>
  <!-- show new password input modal -->
  <VBusHelper
    :reactOn="$constants.EVENTS.PASSWORD_RESET.SHOW_NEW_PASSWORD_INPUT"
    :handler="() => {
      $refs.newPasswordModal?.show();
    }"
  />

  <!-- close modal on success -->
  <VBusHelper
    :reactOn="$constants.EVENTS.PASSWORD_RESET.RESET_SUCCESS"
    :handler="() => {
      $refs.newPasswordModal?.hide();
    }"
  />

  <!-- modal nouveau mot de passe -->
  <DialogComponent
    ref="newPasswordModal"
    type="bottomsheet"
    noInnerPadding
    hideCloseButton
  >
    <div class="p-6">
      <div class="text-xl font-bold mb-2 title-color">
        {{ isMigrationMode ? 'Bienvenue !' : 'Nouveau mot de passe' }}
      </div>
      <div class="text-sm text-slate-500 mb-6">
        {{ isMigrationMode
          ? 'Définissez votre nouveau mot de passe pour accéder à votre compte migré'
          : 'Entrez votre nouveau mot de passe (minimum 6 caractères)' }}
      </div>

      <!-- nouveau mot de passe -->
      <div class="mb-4">
        <input
          class="inputComponent"
          v-model="passwordResetStore.newPassword"
          label="Nouveau mot de passe"
          type="password"
          placeholder="********"
          :required="true"
        />
      </div>

      <!-- confirmer mot de passe -->
      <div class="mb-4">
        <input
          class="inputComponent"
          v-model="passwordResetStore.confirmPassword"
          label="Confirmer le mot de passe"
          type="password"
          placeholder="********"
          :required="true"
        />
      </div>

      <!-- message d'erreur si les mots de passe ne correspondent pas -->
      <div v-if="passwordMismatch" class="text-red-500 text-sm mb-4">
        Les mots de passe ne correspondent pas
      </div>

      <!-- message d'erreur du serveur -->
      <div v-if="passwordResetStore.error" class="text-red-500 text-sm mb-4">
        {{ passwordResetStore.error }}
      </div>

      <!-- boutons -->
      <div class="flex gap-3">
        <button
          @click="$refs.newPasswordModal?.hide(); $bus.emit($constants.EVENTS.PASSWORD_RESET.CANCEL)"
          class="flex-1! buttonComponent py-4 bg-slate-100! border border-primary text-primary!"
        >
          annuler
        </button>
        <button
          @click="submitNewPassword"
          class="flex-1! buttonComponent py-4"
          :disabled="!canSubmitPassword || passwordResetStore.loading"
          :loading="passwordResetStore.loading"
        >
          réinitialiser
        </button>
      </div>
    </div>
  </DialogComponent>
</template>

<script>
export default {
  name: 'PasswordReset',

  computed: {
    passwordResetStore() {
      return this.$stores?.passwordReset?.state || {
        newPassword: '',
        confirmPassword: '',
        loading: false,
        error: null
      };
    },

    passwordMismatch() {
      return this.passwordResetStore.newPassword &&
             this.passwordResetStore.confirmPassword &&
             this.passwordResetStore.newPassword !== this.passwordResetStore.confirmPassword;
    },

    canSubmitPassword() {
      return this.passwordResetStore.newPassword &&
             this.passwordResetStore.newPassword.length >= 6 &&
             this.passwordResetStore.newPassword === this.passwordResetStore.confirmPassword;
    },

    isMigrationMode() {
      return this.passwordResetStore.isMigration || false;
    }
  },

  methods: {
    submitNewPassword() {
      if (this.canSubmitPassword) {
        this.$bus.emit(this.$constants.EVENTS.PASSWORD_RESET.SUBMIT_NEW_PASSWORD, {
          password: this.passwordResetStore.newPassword
        });
      }
    }
  }
};
</script>
